export const normalizeNonRxUpc = (value) =>
  String(value || '')
    .replace(/\s+/g, '')
    .trim();

export const getNonRxUpcVariants = (upc) => {
  const normalized = normalizeNonRxUpc(upc);
  const variants = new Set();
  if (!normalized) {
    return variants;
  }
  variants.add(normalized);
  if (/^\d{11}$/.test(normalized)) {
    variants.add(`0${normalized}`);
  }
  if (/^\d{12,13}$/.test(normalized) && normalized.startsWith('0')) {
    variants.add(normalized.slice(1));
  }
  return variants;
};

export const isSellableCatalogProduct = (product) => {
  if (!product) {
    return false;
  }
  const deleted =
    product.is_deleted === true ||
    product.is_deleted === 'true' ||
    product.is_deleted === 1 ||
    product.is_deleted === '1';
  if (deleted) {
    return false;
  }
  return String(product.status || 'active').trim().toLowerCase() === 'active';
};

export const isEmptyCatalogPickerRow = (item) => {
  if (!item) {
    return false;
  }
  if (item.is_custom === true || item.is_custom === 'true') {
    return false;
  }
  if (item.non_rx_product_id) {
    return false;
  }
  return (
    !String(item.item_number || '').trim() &&
    !String(item.description || '').trim() &&
    !String(item.upc || '').trim()
  );
};

export const findMatchingNonRxCartIndex = (
  items,
  { productId, upc, skipIndex } = {}
) => {
  const list = Array.isArray(items) ? items : [];
  const variants = upc ? getNonRxUpcVariants(upc) : new Set();
  const productKey =
    productId != null && productId !== '' ? String(productId) : '';
  return list.findIndex((item, index) => {
    if (skipIndex != null && index === skipIndex) {
      return false;
    }
    if (!item) {
      return false;
    }
    if (
      productKey &&
      item.non_rx_product_id &&
      String(item.non_rx_product_id) === productKey
    ) {
      return true;
    }
    const itemUpc = normalizeNonRxUpc(item.upc);
    return Boolean(itemUpc && variants.has(itemUpc));
  });
};

export const incrementNonRxCartQty = (item, extra = 1) => ({
  ...item,
  qty: (parseFloat(item && item.qty) || 1) + extra,
});

export const addOrIncrementNonRxCartItem = (items, newItem, match = {}) => {
  const next = Array.isArray(items) ? [...items] : [];
  const extraQty = parseFloat(newItem && newItem.qty) || 1;
  const existingIndex = findMatchingNonRxCartIndex(next, match);
  if (existingIndex >= 0) {
    next[existingIndex] = incrementNonRxCartQty(next[existingIndex], extraQty);
    return { items: next, merged: true };
  }
  const emptyIndex = next.findIndex(isEmptyCatalogPickerRow);
  if (emptyIndex >= 0) {
    const current = next[emptyIndex];
    next[emptyIndex] = {
      ...newItem,
      id: current.id,
      isDraft: current.isDraft !== false,
    };
    return { items: next, merged: false };
  }
  next.push(newItem);
  return { items: next, merged: false };
};



// WEBPACK FOOTER //
// ./src/utils/nonRxCart.js